/* This files contains for ALL activities types and overall description. This is structured to contain two categories:
activities in the white season or green season.  */
export const activities = [
    {
    id: 0,
    category: 'activities',
    name: 'White Season',
    nameJ: '白い・雪季節',
    nameCh1: '冬季',
    nameCh2: '冬季',
    caption: 'As the host of the 1998 Nagano Winter Olympic Games, Hakuba is internationally renowned for its snow sports, offering skiing, snowboarding, and cross-country skiing for all skill levels. In addition to these, Hakuba offers a variety of fun activities for both adults and children.',
    captionJ: '1998年長野冬季オリンピックの開催地である白馬は、スノースポーツで国際的に知られており、スキー、スノーボード、クロスカントリースキーをあらゆるレベルの人々が楽しめます。さらに、大人も子供も楽しめるさまざまなアクティビティも用意されています。',
    captionCh1: '作为1998年长野冬季奥运会的举办地，白马因雪上运动而闻名国际，提供适合各个水平的滑雪、单板滑雪和越野滑雪。此外，这里还有适合成人和儿童的各种有趣活动。',
    captionCh2: '作為1998年長野冬季奧運會的舉辦地，白馬因雪上運動而聞名國際，提供適合各個水平的滑雪、單板滑雪和越野滑雪。此外，這裡還有適合成人和兒童的各種有趣活動。',
    activities: [
        {
            id: 0,
            name: 'Skiing and Snowboarding',
            nameJ: 'スキーとスノーボード',
            nameCh1: '滑雪和单板滑雪',
            nameCh2: '滑雪和單板滑雪',
            image: '/assets/images/activities/whiteseason/snowboarding.jpg',
            text: 'Hakuba Goryu Snow Park is the closest to the hotel, just over 500 meters away. With a single lift pass, you can enjoy access to three snow parks: Hakuba Goryu, Hakuba47, and Iimori. Additionally, you can explore other snow parks throughout the Hakuba Valley.',
            textJ: '白馬五竜スノーパークはホテルから最も近く、わずか500メートルちょっとの距離にあります。1枚のリフト券で、白馬五竜、Hakuba47、飯森の3つのスノーパークを楽しむことができます。さらに、白馬バレー全体に広がる他のスノーパークも楽しめます。',
            textCh1: '白马五龙滑雪场距离酒店最近，仅500多米。凭一张缆车票，您可以畅玩白马五龙、Hakuba47和饭森三个滑雪场。此外，您还可以享受白马山谷的其他滑雪场。',
            textCh2: '白馬五龍滑雪場距離酒店最近，僅500多米。憑一張纜車票，您可以暢玩白馬五龍、Hakuba47和飯森三個滑雪場。此外，您還可以享受白馬山谷的其他滑雪場。'
        },
        {
            id: 1,
            name: 'Crosscountry Skiing',
            nameJ: 'クロスカントリースキー',
            nameCh1: '越野滑雪',
            nameCh2: '越野滑雪',
            image: '/assets/images/activities/whiteseason/crosscountry.jpg',
            text: 'Explore the serenity of the winter forest and experience the excitement of cross-country ski tours in Hakuba. Evergreen Backcountry Guides offers guided cross-country ski tours through the tranquil trails of Iwatake or the challenging Olympic courses at Hakuba’s Snow Harp. For more details, visit https://www.evergreen-backcountry.com/cross-country-ski-tours/.',
            textJ: '冬の森の静けさを感じながら、白馬でクロスカントリースキーの楽しさを体験しましょう。Evergreen Backcountry Guidesでは、静かな岩岳のコースや、挑戦的な白馬スノーハープのオリンピックコースでガイド付きのクロスカントリースキーツアーを提供しています。詳細は、https://www.evergreen-backcountry.com/cross-country-ski-tours/ をご覧ください。',
            textCh1: '探索冬季森林的宁静，体验白马的越野滑雪之旅的乐趣。Evergreen Backcountry Guides 提供在宁静的岩岳滑雪道或挑战性的白马雪之弦奥林匹克滑雪道上的指导滑雪之旅。更多信息，请访问 https://www.evergreen-backcountry.com/cross-country-ski-tours/。',
            textCh2: '探索冬季森林的寧靜，體驗白馬的越野滑雪之旅的樂趣。Evergreen Backcountry Guides 提供在寧靜的岩岳滑雪道或挑戰性的白馬雪之弦奧林匹克滑雪道上的導覽越野滑雪之旅。更多資訊，請訪問 https://www.evergreen-backcountry.com/cross-country-ski-tours/。'
        },
        {
            id: 2,
            name: 'Snowmobile and Walking Tours',
            nameJ: 'スノーモービルツアーやウォーキングツアー',
            nameCh1: '雪地摩托和徒步旅行',
            nameCh2: '雪地摩托和徒步旅行',
            image: '/assets/images/activities/whiteseason/snowmobile.jpg',
            text: 'Lion Adventure offers guided snowmobile and walking tours in the nearby forests. Their office is located directly across the street from Escal Plaza. Reservations are required. For more information, visit https://hakuba.lion-adventure.com/en/.',
            textJ: 'Lion Adventureでは、近くの森でガイド付きのスノーモービルツアーやウォーキングツアーを提供しています。オフィスはエスカールプラザの向かい側にあります。予約が必要です。詳細は、https://hakuba.lion-adventure.com/en/ をご覧ください。',
            textCh1: 'Lion Adventure 提供附近森林中的导览雪地摩托和徒步旅行活动。他们的办公室位于 Escal Plaza 对面的街道上。需要预约。更多信息，请访问 https://hakuba.lion-adventure.com/en/。',
            textCh2: 'Lion Adventure 提供在附近森林中的導覽雪地摩托和徒步旅行活動。他們的辦公室位於 Escal Plaza 對面的街道上。需要預約。更多資訊，請訪問 https://hakuba.lion-adventure.com/en/。'
        },
        {
            id: 3,
            name: 'Snow Tubing',
            nameJ: 'スノーチュービング',
            nameCh1: '雪地管道',
            nameCh2: '雪地管道',
            image: '/assets/images/activities/whiteseason/snowtubing.jpg',
            text:'Kashimayari is a lesser-known resort in the Hakuba Valley. It features a 500-meter-long snow tubing run, where visitors can ride in a donut-shaped sled from the top of the slope to the bottom. The pricing is reasonable. To reach the resort from Escal Plaza, take the valley shuttle bus. For more information, visit: https://www.kashimayari.net/snow/snowadventure/.',
            textJ: '鹿島槍は白馬バレーであまり知られていないリゾートです。500メートルのスノーチュービングコースがあり、ドーナツ型のソリに乗って斜面の頂上からふもとまで滑り降りることができます。料金も手頃です。エスカールプラザからはバレーシャトルバスでアクセス可能です。詳細は、https://www.kashimayari.net/snow/snowadventure/ をご覧ください。',
            textCh1: '鹿岛枪（Kashimayari）是白马山谷中较不知名的滑雪胜地。这里有一条500米长的雪地管道，游客可以在类似圆圈的雪橇中从顶部滑到底部。价格合理。从 Escal Plaza 出发，需要乘坐山谷接驳巴士前往。更多信息，请访问：https://www.kashimayari.net/snow/snowadventure/。',
            textCh2: '鹿島槍（Kashimayari）是白馬山谷中較不為人知的滑雪勝地。這裡擁有一條500米長的雪地管道，遊客可以乘坐圓形的雪橇從坡道頂端滑到底部。價格合理。從 Escal Plaza 出發，需要搭乘山谷接駁巴士前往。更多資訊，請訪問：https://www.kashimayari.net/snow/snowadventure/。'
        },
        {
            id: 4,
            name: 'Trampoline',
            nameJ: 'トランポリン',
            nameCh1: '蹦床',
            nameCh2: '蹦床',
            image: '/assets/images/activities/whiteseason/trempoline.jpg',
            text:'Popular among families with kids, Hakubounce is a trampoline park where you can jump, flip, and tumble to your heart’s content. Hakubounce is about a 15-minute walk away. For more information, visit https://hakubounce.com/.en/.',
            textJ: '子供連れの家族に人気のある「Hakubounce」は、ジャンプやフリップ、タムブルを思う存分楽しめるトランポリンパークです。Hakubounceまでの距離は徒歩約15分です。詳細は https://hakubounce.com/.en/ をご覧ください。',
            textCh1: '受到家庭和孩子们的欢迎，Hakubounce 是一个可以尽情跳跃、翻转和翻腾的蹦床公园。Hakubounce 距离酒店步行约15分钟。更多信息，请访问 https://hakubounce.com/.en/。',
            textCh2: '深受家庭和孩子們喜愛的 Hakubounce 是一個可以盡情跳躍、翻轉和翻滾的蹦床公園。Hakubounce 距離酒店步行約15分鐘。更多資訊，請訪問 https://hakubounce.com/.en/。'
        },
        {
            id: 5,
            name: 'Snow Monkey Tour',
            nameJ: 'スノーモンキーツアー',
            nameCh1: '雪猴旅游',
            nameCh2: '雪猴旅游',
            image: '/assets/images/activities/whiteseason/snowmonkey.jpg',
            text:'You may have seen pictures of it before, but visiting the Snow Monkey Park is a fantastic off-day activity. The park is approximately a 2-hour bus ride away. Unless you have a car, we recommend taking the guided tour offered by Snow Monkey Tours (https://www.snowmonkeytour.com/). This tour also includes a visit to Zenkoji, a Buddhist temple in Nagano City, and takes the entire day.',
            textJ: '以前に写真で見たことがあるかもしれませんが、スノーモンキー 公園を訪れるのは素晴らしいオフデーアクティビティです。公園まではバスで約2時間の距離です。車がない場合は、Snow Monkey Tours（https://www.snowmonkeytour.com/）が提供するガイドツアーをお勧めします。このツアーには、長野市にある仏教寺院「善光寺」の訪問も含まれており、1日かかります。',
            textCh1: '你可能以前见过这些照片，但访问雪猴公园是一个很棒的休闲活动。公园距离约需2小时的巴士车程。如果没有车，我们建议参加由 Snow Monkey Tours（https://www.snowmonkeytour.com/）提供的导览团。该导览团还包括访问长野市的善光寺，整个行程需要一天时间。',
            textCh2: '你可能之前已經見過這些照片，但參觀雪猴公園是一個很棒的休閒活動。公園距離約需2小時的巴士車程。如果沒有車，我們建議參加由 Snow Monkey Tours（https://www.snowmonkeytour.com/）提供的導覽團。這個導覽團還包括參觀長野市的善光寺，整個行程需要一天時間。'
        }
    ]
    },
    {
    id: 1,
    category: 'activities',
    name: 'Green Season',
    nameJ: '緑の季節',
    nameCh1: '绿季',
    nameCh2: '綠季',
    caption: 'Hakuba is an all-seasons resort town. Visitors from across Japan and around the world come to enjoy activities such as hiking, horseback riding, mountain biking, or simply strolling and relaxing amidst the breathtaking scenery.',
    captionJ: '白馬は四季折々のリゾート地です。日本国内外から多くの人々が訪れ、ハイキングや乗馬、マウンテンバイクなどを楽しんだり、ただ美しい景色の中を散策してリラックスしたりしています。',
    captionCh1: '白马是一个四季皆宜的度假小镇。来自日本各地和世界各国的游客前来这里，享受徒步旅行、骑马、山地自行车，或者只是漫步其中，放松于美丽的自然风光中。',
    captionCh2: '白馬是一個四季皆宜的度假小鎮。來自日本各地和世界各國的遊客前來這裡，享受徒步旅行、騎馬、山地自行車，或者只是漫步其中，放鬆於美麗的自然風光中。',
    activities: [
        {
            id: 0,
            name: 'Sightseeing',
            nameJ: '観光',
            nameCh1: '观光',
            nameCh2: '觀光',
            image: '/assets/images/activities/greenseason/siteseeing.jpg',
            text: 'The natural beauty in Hakuba shines in spring, summer, and fall. In spring, vibrant cherry blossoms contrast with lingering snow. Summer brings lush forests and clear rivers, while fall transforms the landscape into fiery reds, oranges, and yellows. Each season offers a chance to leisurely enjoy the stunning scenery.',
            textJ: '白馬の自然美は春、夏、秋にも輝きを増します。春には鮮やかな桜が残雪と美しいコントラストを描きます。夏は青々とした森林や澄んだ川が広がり、秋には紅葉が山々を鮮やかな赤、オレンジ、黄色に染め上げます。どの季節も、白馬の美しい景色をゆったりと楽しむことができます。',
            textCh1: '白马的自然美景在春、夏、秋三季同样迷人。春天，山间点缀着鲜艳的樱花，与残雪形成美丽的对比。夏天则带来郁郁葱葱的森林和清澈的河流。秋天，风景被火红、橙黄的秋叶装点成一幅美丽的画卷。每个季节，白马都提供了悠闲享受自然美景的机会。',
            textCh2: '白馬的自然美景在春、夏、秋三季同樣迷人。春天，山間點綴著鮮豔的櫻花，與殘雪形成美麗的對比。夏天則帶來郁郁蔥蔥的森林和清澈的河流。秋天，風景被火紅、橙黃的秋葉裝點成一幅美麗的畫卷。每個季節，白馬都提供了悠閒享受自然美景的機會。'
        },
        {
            id: 1,
            name: 'Hiking and Mountain Climbing',
            nameJ: 'ハイキングと登山',
            nameCh1: '徒步旅行和登山',
            nameCh2: '徒步旅行',
            image: '/assets/images/activities/greenseason/hiking.jpg',
            text: 'Hakuba is a prime destination for hiking and mountain climbing, featuring diverse trails and stunning peaks. From easy walks through lush forests to challenging climbs with breathtaking views, the area caters to all skill levels. Whether you’re looking for a leisurely hike or a rigorous climb, Hakuba offers unforgettable outdoor adventures.',
            textJ: '白馬はハイキングや登山に最適な場所で、さまざまなトレイルと美しい山々が広がっています。緑豊かな森の中の穏やかなコースから、絶景を楽しめる挑戦的な登山まで、すべてのスキルレベルに対応しています。気軽なハイキングでも本格的な登山でも、白馬のアウトドアアドベンチャーは忘れられない体験を提供します。',
            textCh1: '白马是徒步旅行和登山的绝佳目的地，拥有多样的路线和壮丽的山峰。从森林中的平缓步道到风景如画的挑战性攀登，这里适合各种技能水平的人士。无论是轻松的徒步旅行还是刺激的登山，白马都能提供难忘的户外冒险体验。',
            textCh2: '白馬是徒步旅行和登山的絕佳目的地，擁有多樣的步道和壯麗的山峰。從森林中的平緩步道到風景如畫的挑戰性攀登，這裡適合各種技能水平的遊客。無論是輕鬆的徒步旅行還是刺激的登山，白馬都能提供難忘的戶外冒險體驗。'
        },
        {
            id: 2,
            name: 'Mountain Biking',
            nameJ: '',
            nameCh1: '',
            nameCh2: '',
            image: '/assets/images/activities/greenseason/mountainBiking.jpg',
            text: 'Hakuba is ideal for mountain biking, with trails for all skill levels. Riders can explore thrilling downhill runs and scenic cross-country routes at popular spots like Hakuba Iwatake and Hakuba 47. The well-maintained trails and stunning mountain views make Hakuba a top destination for both adventurous and casual cyclists.',
            textJ: '白馬はマウンテンバイキングに最適な場所で、さまざまなスキルレベルに対応したトレイルがあります。白馬岩岳や白馬47などの人気スポットで、スリリングなダウンヒルコースや美しいクロスカントリールートを楽しめます。手入れの行き届いたトレイルと絶景が、冒険好きなサイクリストにもカジュアルなサイクリストにも最適な目的地です。',
            textCh1: '白马是山地自行车的理想地，有适合各种技能水平的路线。在白马岩岳和白马47等热门地点，骑行者可以享受刺激的下坡赛道和风景如画的越野路线。良好的道路维护和迷人的山景，使白马成为冒险者和休闲骑行者的绝佳选择。',
            textCh2: '白馬是山地自行車的理想目的地，擁有各種適合不同技能水平的路線。在白馬岩岳和白馬47等熱門地點，騎行者可以享受刺激的下坡路徑和風景如畫的越野路線。良好的路面維護和迷人的山景，使白馬成為冒險者和休閒騎行者的絕佳選擇。'
        },
        {
            id: 3,
            name: 'Paragliding',
            nameJ: 'パラグライディング',
            nameCh1: '滑翔伞',
            nameCh2: '滑翔傘',
            image: '/assets/images/activities/greenseason/paragliding.jpg',
            text: 'Hakuba offers thrilling paragliding with breathtaking views of the mountains and valleys. Popular spots like Hakuba Goryu, Hakuba Happo, and Hakuba Iwatake feature stunning aerial scenery. Whether you\'re a seasoned paraglider or a beginner, Hakuba\’s landscape promises an unforgettable adventure.',
            textJ: '白馬では、山々や谷間の息を呑むような景色を楽しみながら、スリリングなパラグライディングが体験できます。白馬五竜、白馬八方、白馬岩岳などの人気スポットでは、素晴らしい空中の風景を堪能できます。経験者にも初心者にも、白馬の風景は忘れられない冒険を提供します。',
            textCh1: '白马提供刺激的滑翔伞体验，可以俯瞰到壮丽的山脉和山谷风光。白马五龙、白马八方和白马岩岳等热门地点提供了令人惊叹的空中景色。无论你是经验丰富的滑翔伞爱好者还是新手，白马的风景都能带来难忘的冒险。',
            textCh2: '白馬提供刺激的滑翔傘體驗，讓人可以俯瞰壯麗的山脈和山谷風光。白馬五龍、白馬八方和白馬岩岳等熱門地點提供了令人驚嘆的空中景色。無論你是經驗豐富的滑翔傘愛好者還是新手，白馬的風景都能帶來難忘的冒險。'
        },
        {
            id: 4,
            name: 'Rafting',
            nameJ: 'ラフティング',
            nameCh1: '漂流',
            nameCh2: '漂流',
            image: '/assets/images/activities/greenseason/rafting.jpg',
            text: 'Hakuba offers exciting rafting experiences with stunning river views. Lion Adventure provides guided rafting tours through the area\'s scenic rapids, ensuring a thrilling and safe adventure. For more details, visit https://hakuba.lion-adventure.com/en/activity/hakubahimekawarafting/',
            textJ: '白馬では、壮麗な河川の景色を楽しみながらエキサイティングなラフティングが体験できます。Lion Adventureは、風光明媚な急流を通るガイド付きラフティングツアーを提供しており、スリリングで安全な冒険を保証します。詳細は https://hakuba.lion-adventure.com/en/activity/hakubahimekawarafting/ をご覧ください。',
            textCh1: '白马提供激动人心的漂流体验，拥有壮丽的河流风光。Lion Adventure 提供经过该地区风景如画的急流的指导漂流之旅，确保刺激且安全的冒险。有关更多信息，请访问 https://hakuba.lion-adventure.com/en/activity/hakubahimekawarafting/',
            textCh2: '白馬提供刺激的漂流體驗，享有壯麗的河流風光。Lion Adventure 提供經過該地區風景如畫的急流的導覽漂流之旅，確保刺激且安全的冒險。欲了解更多資訊，請訪問 https://hakuba.lion-adventure.com/en/activity/hakubahimekawarafting/'
        },
        {
            id: 5,
            name: 'Kayaking',
            nameJ: 'カヤック',
            nameCh1: '划艇',
            nameCh2: '划艇',
            image: '/assets/images/activities/greenseason/kayaking.jpg',
            text: 'Hakuba offers thrilling kayaking experiences on Lake Aoki with stunning mountain views. Lion Adventure provides guided kayaking tours for an exciting and safe adventure. For more details, visit https://hakuba.lion-adventure.com/en/activity/lakekayak/',
            textJ: '白馬では、白馬近くの青木湖で壮麗な山々の景色を楽しみながらスリリングなカヤック体験ができます。Lion Adventureは、安全で刺激的なガイド付きカヤックツアーを提供しています。詳細は https://hakuba.lion-adventure.com/en/activity/lakekayak/ をご覧ください。',
            textCh1: '白马提供在青木湖上的刺激划艇体验，湖边景色优美，山景壮丽。Lion Adventure 提供安全且令人兴奋的导览划艇之旅。有关更多信息，请访问 https://hakuba.lion-adventure.com/en/activity/lakekayak/',
            textCh2: '白馬提供在青木湖上的刺激划艇體驗，湖邊的山景壯麗。Lion Adventure 提供安全且充滿刺激的導覽划艇之旅。欲了解更多資訊，請訪問 https://hakuba.lion-adventure.com/en/activity/lakekayak/'
        }
    ]
    }
]